/* eslint-disable eqeqeq */
import axios from 'axios'
import { Message } from 'element-ui'

const baseApi = process.env.VUE_APP_BASE_API

const service = axios.create({
  headers: {
    'authorization': ''
  },
  baseURL: baseApi,
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error)
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (Number(res.error.code) === 0 || res.error.code === 'OK') {
      return res
    } else {
      const ErrMsg = res.error.msg
      Message({
        message: ErrMsg,
        type: 'error',
        duration: 2 * 1000
      })
      // 将错误码抛给错误回调
      return Promise.reject(res.error.code)
    }
  },
  error => {
    if (error && error == 'Error: Network Error') {
      // 网络异常
      Message({
        message: '网络异常',
        type: 'warning',
        duration: 3000
      })
    }
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = '请求错误，未找到该资源'
          break
        case 405:
          error.message = '请求方法未允许'
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 502:
          error.message = '服务器异常'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        default:
          error.message = '未知错误'
          break
      }
      Message({
        message: error.message,
        type: 'warning',
        duration: 3000,
        center: true
      })
    }
    return Promise.reject(error)
  }
)

export default service
